import { useEffect } from 'react';

import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext';
import UserEventHandler from '@sendbird/uikit-react/handlers/UserEventHandler';

import {
  ClientChatTypes,
  setClientTabUnreadCount,
  setUnreadCount,
  TypeOfUser,
  userIdSelector,
} from '@pharmaplan/common';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import audio from '../../../assets/audio/live_chat.mp3';

import { useAppDispatch } from '../../useAppDispatch';
import { useAppSelector } from '../../useAppSelector';

const uniqueId = 'uniqueId';

const useAdminUnreadChats = () => {
  const dispatch = useAppDispatch();

  const userId = useAppSelector(userIdSelector);

  const store = useSendbirdStateContext();
  const sdk = store?.stores?.sdkStore?.sdk;
  const notificationSound = new Audio(audio);

  const handleAdminUnread = async (totalUnread: number) => {
    try {
      const { groupChannelUnreadMessageCount: pharmacistCount = 0 } = await sdk?.groupChannel.getUnreadItemCount({
        customTypesFilter: [`+${TypeOfUser.pharmacist}`, `${userId}+${TypeOfUser.pharmacist}`],
      }) ?? {};
      const { groupChannelUnreadMessageCount: technicianCount = 0 } = await sdk?.groupChannel.getUnreadItemCount({
        customTypesFilter: [`+${TypeOfUser.technician}`, `${userId}+${TypeOfUser.technician}`],
      }) ?? {};
      const { groupChannelUnreadMessageCount: studentCount = 0 } = await sdk?.groupChannel.getUnreadItemCount({
        customTypesFilter: [`+${TypeOfUser.student}`, `${userId}+${TypeOfUser.student}`],
      }) ?? {};

      const { groupChannelUnreadMessageCount: pharmacyCount = 0 } = await sdk?.groupChannel.getUnreadItemCount({
        customTypesFilter: [`+${TypeOfUser.pharmacy}`, `${userId}+${TypeOfUser.pharmacy}`],
      }) ?? {};

      dispatch(
        setClientTabUnreadCount({
          [ClientChatTypes.pharmacist]: pharmacistCount,
          [ClientChatTypes.student]: studentCount,
          [ClientChatTypes.technician]: technicianCount,
          [ClientChatTypes.pharmacy]: pharmacyCount,
          [ClientChatTypes.users]:
            totalUnread - technicianCount - studentCount - pharmacistCount - pharmacyCount,
        }),
      );
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveUnreadCount = () => {
    sdk.groupChannel
      ?.getTotalUnreadMessageCount()
      .then((unread) => {
        dispatch(setUnreadCount(unread));
        handleAdminUnread(unread);
      });
  };

  useEffect(() => {
    const handler = new UserEventHandler({
      onTotalUnreadMessageCountChanged: (unread) => {
        const { groupChannelCount } = unread ?? {};
        dispatch(setUnreadCount(groupChannelCount));
        handleAdminUnread(groupChannelCount);

        if (unread.groupChannelCount) {
          notificationSound.play();
        }
      },
    });

    sdk?.addUserEventHandler?.(uniqueId, handler);
    retrieveUnreadCount();

    return () => {
      sdk?.removeUserEventHandler?.(uniqueId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdk]);
};

export default useAdminUnreadChats;
